/**
 * @description 用户状态管理模块
 */
export default {
  namespaced: true,
  state: {
    userInfo: JSON.parse(localStorage.getItem('userInfo')) || null,
    token: localStorage.getItem('token') || null
  },
  mutations: {
    /**
     * @description 设置用户信息
     */
    SET_USER_INFO (state, userInfo) {
      state.userInfo = userInfo
      if (userInfo) {
        localStorage.setItem('userInfo', JSON.stringify(userInfo))
      } else {
        localStorage.removeItem('userInfo')
      }
    },
    /**
     * @description 设置token
     */
    SET_TOKEN (state, token) {
      state.token = token
      if (token) {
        localStorage.setItem('token', token)
      } else {
        localStorage.removeItem('token')
      }
    }
  },
  actions: {
    /**
     * @description 登录成功后的操作
     */
    loginSuccess ({ commit }, { user, token }) {
      commit('SET_USER_INFO', user)
      commit('SET_TOKEN', user.token)
    },
    /**
     * @description 退出登录
     */
    logout ({ commit }) {
      commit('SET_USER_INFO', null)
      commit('SET_TOKEN', null)
    }
  },
  getters: {
    /**
     * @description 获取用户信息
     */
    getUserInfo: state => state.userInfo
  }
}
